import { render, staticRenderFns } from "./industryInvestment.vue?vue&type=template&id=f153e1b6&"
import script from "./industryInvestment.vue?vue&type=script&lang=js&"
export * from "./industryInvestment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports